/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Priority level of a task
 * @export
 */
export const TaskPriority = {
    Low: 'low',
    Medium: 'medium',
    High: 'high',
    Urgent: 'urgent'
} as const;
export type TaskPriority = typeof TaskPriority[keyof typeof TaskPriority];


export function instanceOfTaskPriority(value: any): boolean {
    for (const key in TaskPriority) {
        if (Object.prototype.hasOwnProperty.call(TaskPriority, key)) {
            if (TaskPriority[key as keyof typeof TaskPriority] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TaskPriorityFromJSON(json: any): TaskPriority {
    return TaskPriorityFromJSONTyped(json, false);
}

export function TaskPriorityFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskPriority {
    return json as TaskPriority;
}

export function TaskPriorityToJSON(value?: TaskPriority | null): any {
    return value as any;
}

export function TaskPriorityToJSONTyped(value: any, ignoreDiscriminator: boolean): TaskPriority {
    return value as TaskPriority;
}

